<template>
  <template v-if="useV2">
    <div class="status-wrapper">
      <div class="status-bar">
        <timeline-step
          v-for="step in timeline"
          :key="step.id"
          :status="step.status"
          :step="step.step"
          :title="step.title"
          :maximumStep="stepCount"
          :configuration="step"
          @titleClicked="currentstep = $event"
          @todoListClicked="emit('todoListClicked')"
        >
          <template v-slot:caption v-if="useV2 && currentstep === step.step">
            <timeline-step-description
              class="mobile"
              :step="step.step"
              :status="selectedStep.status"
            /> </template
        ></timeline-step>
      </div>
      <div class="divider"></div>
      <timeline-step-description :step="selectedStep.step" :status="selectedStep.status" />
    </div>
  </template>

  <template v-else-if="productTypeId === ProductIds.REFI">
    <div class="status-wrapper">
      <div class="status-bar">
        <timeline-step
          v-for="step in timeline"
          :key="step.id"
          :status="step.status"
          :step="step.step"
          :title="step.title"
          :maximumStep="stepCount"
          :configuration="step"
          @todoListClicked="emit('todoListClicked')"
        >
        </timeline-step>
      </div>
    </div>
  </template>
</template>

<script setup lang="ts">
import { defineEmits, onMounted } from "vue";
import useApplicationStatus from "@/composables/application-status/useApplicationStatus";
import { ProductIds } from "@/config/constants";
import TimelineStep from "@/components/timeline/TimelineStep.vue";
import TimelineStepDescription from "@/components/timeline/TimelineStepDescription.vue";
import { useStore } from "vuex";

const store = useStore();

const { productTypeId, useV2, timeline, selectedStep, stepCount, currentstep } =
  useApplicationStatus();

const emit = defineEmits<{
  (e: "todoListClicked"): void;
}>();


</script>
